export const paths = [{ "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M4 5h10v2H6v8H4V5zM2 17h20v2H2v-2zM20.5797 6.162l-6.0104 6.0104-3.182-3.182-1.4142 1.4143 4.5962 4.5962 7.4246-7.4246-1.4142-1.4143z" } }];
export const iconName = 'laptop-checkmark';
export const laptopCheckmark = { iconName, paths };
export default paths;
